import React, { useRef } from 'react';

// ... existing code ...import React, { useState, useRef } from 'react';
import { Box, Avatar, Text, Flex, Icon, Switch, VStack, Button, HStack, Spinner } from '@chakra-ui/react';
import { FaCamera } from 'react-icons/fa';
import Card from 'components/Cards/Card';
import LoadingDataCard from 'components/Cards/LoadingDataCard';
import ConsumerForm from 'components/Forms/ConsumerForm';
import RefreshIcon from 'components/icons/RefreshIcon';
import ConfirmationModal from 'components/confirmationModal/confirmationModal';
import BackButton from 'components/Button/BackButton';
import ChangeUserPassword from 'components/Action/ChangeUserPassword';
// import RefreshIcon from 'components/icons/RefreshIcon';
import { getAddressView, getGenderView, getBooleanView, getAvatarNameView } from 'utils/index';
import { useGetconsumerDetailsQuery , useUpdateConsumerMutation } from 'reducers/consumer.service';
import { useUpdateAvatarMutation , useGetDocumenturlMutation } from 'reducers/Document.service';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import { viewDate, viewDateAndTime } from 'utils/date';
import { useRemoveMfaMutation } from 'reducers/auth.service';
import { useHistory } from 'react-router-dom';

// import { viewMobile } from 'utils/number';
import { CiEdit } from 'react-icons/ci';

import { mapResponseToDefaults } from 'utils/default-util';
import { CONSUMER_DEFAULT_VALUES } from 'constants/consumer';
import 'assets/css/viewlayout.scss';
import 'assets/css/Preview.css';
import { AuthContext } from 'contexts/user.context';

const ViewConsumer = () => {
    const { id } = useParams();
    const [avatar, setavatar] = React.useState(null);
    const [getDocumentUrl] = useGetDocumenturlMutation();
    const [isOpen, setisOpen] = React.useState(false);
    const { USERTYPE } = React.useContext(AuthContext);
    const { data, isLoading, refetch, isFetching } = useGetconsumerDetailsQuery({ id });
    const history = useHistory();
    const searchparams = new URLSearchParams(history.location.search);
    const isEdit = searchparams.get('isEdit') === 'true';

    const [removeMfa, { isLoading: deleteLoading }] = useRemoveMfaMutation();
    const [updateConsumer] = useUpdateConsumerMutation();
    const [updateAvatar, { isLoading: updateAvatarLoading }] = useUpdateAvatarMutation();

    const mfaValue = data?.authData?.isTwoMfaEnable || false;

    React.useEffect(() => {
        if (data && data?.avatar) {
            getDocumentUrl({ url: data?.avatar }).unwrap().then((res) => {
                setavatar(res);
            }).catch(() => {
                setavatar(null);
            });
        }
    }, [data]);

    const setisEdit = ()=>{
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('isEdit', !isEdit);

        history.replace({
            pathname: location.pathname,
            search: searchParams.toString()
        });
    };

    const onClickDelete = ()=>{
        setisOpen(!isOpen);
    };

    const handleDeleteAvatar = ()=>{
        setisOpen(false);

        updateConsumer({ id , body: { avatar: null } }).unwrap().then(()=>{
            refetch();
        });
    };

    const fileInputRef = useRef(null);

    const handlePhotoUpload = () => {
        fileInputRef.current.click();
    };
    const handleEdit = ()=>{
        setisEdit(!isEdit);
    };
    const afterUpdateHandler = ()=>{
        setisEdit(false);
        refetch();
    };
    const handleMfa = ()=>{
        removeMfa({ id , USERTYPE: data?.userType }).unwrap().then(()=>{
            refetch();
        });
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        const allowedTypes = ['image/jpeg', 'image/png'];
        const maxSizeInBytes = 3 * 1024 * 1024;
        if (!allowedTypes.includes(file.type)) {
            alert('Only JPEG and PNG files are allowed.');
            return;
        }
        if (file.size > maxSizeInBytes) {
            alert('File size must be less than or equal to 3MB.');
            return;
        }
        const formdata = new FormData();
        formdata.append('avatar', file);

        // update avatar
        updateAvatar({ id , body: formdata, USERTYPE }).unwrap().then(()=>{
            refetch();
        });
    };
    return (
        <Box pt={{ base: '130px', md: '80px', xl: '65px' }}>
            <ConfirmationModal
                isOpen={isOpen}
                title={'Delete Avatar'}
                onOpen={setisOpen}
                onClose={()=>setisOpen(false)}
                onActionConfirm={handleDeleteAvatar}
                modalBody="Are you sure you want to delete this avatar?"
            />

            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'space-between' }}>

                <BackButton />
                <span>Back</span>
                <Box flex={1} textAlign={'end'}>
                    <RefreshIcon handleRefresh={ refetch}/>
                </Box>
            </div>
            {
                isLoading
                    ? <Card p={0}>
                        <LoadingDataCard />
                    </Card>
                    : <HStack
                        width={'100%'}
                        gap={'1rem'}
                        mb="1rem"
                        alignItems={'start'}
                        mt={'1rem'}
                    >
                        <Box h={'100%'} flex={1} p={4} borderRadius="lg" boxShadow="md" border="1px solid #E2E8F0" bg="white">

                            <div>
                                <div
                                    className="preview-heading"
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginBottom: '16px',
                                        borderBottom: '1px solid #e0e0e0',
                                        paddingBottom: '8px'
                                    }}
                                >
                                    <p
                                        style={{
                                            fontWeight: '600',
                                            fontSize: '13px',
                                            textTransform: 'uppercase',
                                            color: 'black'
                                        }}
                                    >
                                        General Information
                                    </p>
                                    <Button onClick={handleEdit} style={{ fontSize: '13px', color: 'teal' }}>
                                        {
                                            isEdit
                                                ? <>
                                            Cancel
                                                </>
                                                : <>
                                                    <Icon as={CiEdit} w={4} h={4} mr={1} />
                                                    Edit Details

                                                </>
                                        }
                                    </Button>

                                </div>
                                <div className="preview-body">

                                    {
                                        (isEdit)
                                            ? <ConsumerForm
                                                data={ data}
                                                handleCancel={handleEdit}
                                                afterUpdateHandler={afterUpdateHandler}
                                                defaultValues={mapResponseToDefaults(CONSUMER_DEFAULT_VALUES , data) }
                                            />

                                            : <div style={{ lineHeight: '2.5rem' }}>
                                                <p><strong>DID</strong><br />{data?.did}</p>
                                                <p><strong>Email</strong><br />{data?.ContactPointEmailValue}</p>

                                                <p><strong>First Name</strong><br />{data?.FirstName}</p>
                                                <p><strong>Last Name</strong><br />{data?.LastName}</p>
                                                <p><strong>Gender</strong><br />{getGenderView(data?.gender)}</p>
                                                <p><strong>Occupency</strong><br />{ data?.OccupencyType}</p>
                                                <p><strong>BirthDate</strong><br />{viewDate(data?.BirthDate)}</p>
                                                <p><strong>Address</strong><br />{getAddressView(data)}</p>
                                                <p><strong>Is Id Address Current Residence</strong><br />{getBooleanView(data?.isIdAddressCurrentResidence)}</p>
                                                <p><strong>Is On Rent</strong><br />{getBooleanView(data?.isOwnPropertyId?.isOnRent)}</p>
                                                <p><strong>Is Own Property</strong><br />{getBooleanView(data?.isOwnPropertyId?.isOwnProperty)}</p>
                                                <p><strong>Last Updated On</strong><br />{viewDateAndTime(data?.updatedAt)}</p>
                                            </div>

                                    }
                                </div>
                            </div>
                        </Box>
                        <Box h={'110vh'} flex={1} p={4} borderRadius="lg" boxShadow="md" border="1px solid #E2E8F0" bg="white">
                            <VStack align="start" spacing={8}>
                                <Box display="flex" justifyContent="space-between" w="full">
                                    <Text fontWeight="bold">MULTI-FACTOR AUTHENTICATION</Text>
                                    <Switch disabled={ !mfaValue || isFetching} isChecked={mfaValue} onChange={handleMfa} />
                                </Box>
                                {
                                    !mfaValue && <Box>
                                        <p>
                        You don&apos;t have access to enable the MFA for the user.
                                        </p>
                                    </Box>
                                }
                            </VStack>
                            <br />
                            <br />
                            <ChangeUserPassword data={data} refetch={refetch}/>

                        </Box>
                        <Box
                            p="4"
                            h={'110vh'}
                            flex={1}
                            borderRadius="lg"
                            boxShadow="md"
                            border="1px solid #E2E8F0"
                            bg="white"
                        >
                            <Box borderBottom="1px solid #E2E8F0" pb={2}>
                                <Flex justify="space-between" align="center">
                                    <Text fontWeight="bold">PROFILE PHOTO</Text>
                                    <Button disabled={updateAvatarLoading} onClick={handlePhotoUpload} color="teal.500" display="flex" alignItems="center" fontSize="sm">
                                        <Icon as={FaCamera} w={4} h={4} mr={1} />
                                        Change Photo
                                    </Button>
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        style={{ display: 'none' }}
                                        onChange={handleFileChange}
                                    />
                                </Flex>
                            </Box>
                            {
                                (updateAvatarLoading || deleteLoading)
                                    ? <Box width={'100%'} height={'30%'} textAlign={'center'}>
                                        <Spinner
                                            thickness="4px"
                                            speed="0.65s"
                                            mt={'15%'}
                                            emptyColor="var(--primary-border)"
                                            color="var(--primary-color)"
                                            size="xl"
                                        />
                                        <p>Loading avatar please wait...</p>
                                    </Box>
                                    : <Avatar
                                        Avatar
                                        size="2xl"
                                        src={ avatar}
                                        name={ getAvatarNameView(data)}
                                        width="100%"
                                        height='30%'
                                        borderRadius="md"
                                        boxShadow="xl"
                                        mt={8}
                                    />
                            }
                            <Box display="flex" justifyContent="center" mt="8">
                                <Button
                                    onClick={onClickDelete}
                                    fontSize="sm"
                                    color="red.500"

                                    cursor="pointer"
                                >
                                    Delete Photo
                                </Button>
                            </Box>

                        </Box>

                        {/* <Box w="100%" h="20vh">
                            <Card p={0}>
                                <Avatar
                                    size="2xl"
                                    src={avatar}
                                    name={getAvatarNameView(data)}
                                    position="absolute"
                                    bottom="10%"
                                    left="50%"
                                    transform="translateX(-50%)"
                                    border="3px solid white"
                                    boxShadow="lg"
                                />
                            </Card>
                        </Box> */}
                        {/* </Card> */}
                        {/* <Card p={4}>
                            <div className='preview-box'>
                                <div className="preview-heading">
                                    <p>Consumer Details</p>
                                </div>
                                <div className='preview-body' >
                                    <table>
                                        <tr>
                                            <td>
                                                DID
                                            </td>
                                            <td>
                                                {data?.did}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                Gender
                                            </td>
                                            <td>
                                                {getGenderView(data?.gender)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Occupency Type
                                            </td>
                                            <td>
                                                {data?.OccupencyType}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                BirthDate
                                            </td>
                                            <td>
                                                {viewDate(data?.BirthDate)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Address
                                            </td>
                                            <td>
                                                {getAddressView(data)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Is Id Address Current Residence
                                            </td>
                                            <td>
                                                {getBooleanView(data?.isIdAddressCurrentResidence)}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                Is On Rent
                                            </td>
                                            <td>
                                                {getBooleanView(data?.isOwnPropertyId?.isOnRent)}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                is Own Property
                                            </td>
                                            <td>
                                                {getBooleanView(data?.isOwnPropertyId?.isOwnProperty)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Last Updated On
                                            </td>
                                            <td>
                                                {viewDateAndTime(data?.updatedAt)}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </Card> */}
                    </HStack>
            }
        </Box>
    );
};

export default ViewConsumer;
